import { fetch } from '@atlassian/eoc-fetch';
export const getUiPreferencesEndpoint = () => {
  return fetch('/v1/alerts/ui-preferences');
};
export const updateUiPreferencesEndpoint = data => {
  return fetch('/v1/alerts/ui-preferences', {
    method: 'PATCH',
    body: data
  });
};